import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Status } from '../../common/constants';
import { RootState } from '../../store';
import { IInitialSliceState } from '../../common/types/commonTypes';
import api from '../../api';
import { getCookie } from '../../common/utils';
import { configureEverbridgeTokenUrl } from '../../config';

const CONFIGURE_TOKEN: string = 'configureEverbridgeToken';

export interface IEverbridgeUserState extends IInitialSliceState {
  userId: string | null;
  organizationId?: string | null;
}
const initialState: IEverbridgeUserState = {
  status: '',
  error: '',
  msg: '',
  userId: null,
};

export interface IEverbridgeTokenResponse {
  message: string;
  userId?: string;
}

export interface IEverbridgeTokenPyayload {
  secretKeyId: string;
  accessKeyId: string;
  organizationId: string;
  emailId?: string;
}

export const everbridgeToken = createAsyncThunk(
  CONFIGURE_TOKEN,
  async (
    everbridgeTokenPayload: IEverbridgeTokenPyayload,
    { rejectWithValue }
  ) => {
    try {
      const emailId: string = decodeURIComponent(getCookie('email'));
      everbridgeTokenPayload.emailId = emailId;
      //   const payload: IEverbridgeTokenPyayload = {
      //     everbridgeToken: `Bearer ${everbridgeToken}`,
      //     emailId,
      //   };
      const response = await api.post<IEverbridgeTokenResponse>(
        configureEverbridgeTokenUrl,
        everbridgeTokenPayload
      );

      const everbridgeTokenResponse: IEverbridgeTokenResponse = response.data;
      return everbridgeTokenResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const everbridgeTokenSlice = createSlice({
  name: CONFIGURE_TOKEN,
  initialState,
  reducers: {
    setUserId: (state, action) => {
      state.userId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(everbridgeToken.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = '';
      })
      .addCase(everbridgeToken.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.userId = action.payload?.userId;
        state.status = Status.SUCCESS;
      })
      .addCase(everbridgeToken.rejected, (state, action) => {
        const errorPayload = action.payload as {
          response?: {
            data?: { error?: { message?: string }; message?: string };
          };
        };
        state.msg =
          errorPayload.response?.data?.error?.message ||
          errorPayload.response?.data?.message ||
          'Unknown error occurred';
        state.status = Status.FAILED;
      });
  },
});

export const actions = {
  everbridgeTokenSlice,
  ...everbridgeTokenSlice.actions,
};

export const selector = (state: RootState) => state.everbridgeTokenApi;

export default everbridgeTokenSlice.reducer;
